import React, { useState, useEffect, useRef } from 'react';
import theme from './Cards.module.scss';
import { classnames } from '@/utils/html';
import { ExpandableCardProps } from '.';
import SimpleCard from './SimpleCard';
import AnimateHeight from 'react-animate-height';
import { LoadingIndicator, Sticky, StickyContainer } from '@ygtechnologies/bygr-frontend-component-library';

const ExpandableCard: React.FC<ExpandableCardProps> = ({
    children,
    expanded,
    lazy = true,
    expandableContent,
    className,
    type = 'outside',
    stickyMode = 'none',
    //expandHandleComponent = ExpandableCardHandle,

    containerClassName,
    ...rest
}) => {
    const [loaded, setLoaded] = useState(!lazy);
    const expandContainerRef = useRef<HTMLDivElement>(null);
    const shouldAnimate = useRef(!expanded);

    useEffect(() => {
        if (expanded && !loaded) {
            setLoaded(true);
        }
    }, [expanded, loaded]);

    // useEffect(() => {
    //     if (expanded && expandContainerRef.current) {
    //         expandContainerRef.current.scrollIntoView();
    //     }
    // }, [expanded]);

    const isSticky = stickyMode === 'always' || (stickyMode === 'expanded' && expanded);

    if (type === 'inside' || type === 'inside-bordered') {
        return (
            <StickyContainer>
                <SimpleCard
                    className={classnames(theme.expandable, theme.inside, className, {
                        [theme.expanded]: expanded,
                        [theme.bordered]: type === 'inside-bordered',
                    })}
                    {...rest}>
                    {/* <Sticky
                    boundaryElement={'.' + theme.card}
                    className={theme.stickyWrapper}
                    stickyClassName={theme.sticky}>
                    <div className={theme.content}>{children}</div>
                </Sticky> */}
                    {/* <div className={theme.content} style={{ position: 'sticky', top:"50px", zIndex:5000 }}>
                    {children}
                </div> */}

                    <Sticky stickyClassName={theme.sticky} enabled={isSticky}>
                        <div className={theme.content}>{children}</div>
                    </Sticky>

                    <div className={classnames(theme.expandableSection, { [theme.expanded]: expanded })}>
                        <AnimateHeight
                            duration={shouldAnimate.current ? 250 : 0}
                            style={{ width: '100%' }}
                            height={loaded && expanded ? 'auto' : 0}
                            className={theme.test}
                            onAnimationEnd={() => (shouldAnimate.current = true)}>
                            <div className={theme.expandableContent}>
                                {loaded ? expandableContent : <LoadingIndicator />}
                            </div>
                        </AnimateHeight>
                    </div>
                </SimpleCard>
            </StickyContainer>
        );
    }

    return (
        <div className={classnames(theme.expandableCardContainer, containerClassName)} ref={expandContainerRef}>
            <SimpleCard
                className={classnames(theme.expandable, className, {
                    [theme.joined]: type === 'joined',
                    [theme.outside]: type === 'outside',
                    [theme.expanded]: expanded,
                })}
                {...rest}>
                {children}
            </SimpleCard>

            <div
                className={classnames(theme.expandableSection, {
                    [theme.joined]: type === 'joined',
                    [theme.expanded]: expanded,
                })}>
                <AnimateHeight
                    className={classnames({ [theme.joined]: type === 'joined' })}
                    duration={shouldAnimate.current ? 250 : 0}
                    style={{ width: '100%' }}
                    height={loaded && expanded ? 'auto' : 0}
                    onAnimationEnd={() => (shouldAnimate.current = true)}>
                    <div className={theme.expandableContent}>{loaded ? expandableContent : <LoadingIndicator />}</div>
                </AnimateHeight>
            </div>
        </div>
    );
};

export default ExpandableCard;